export class WindowService {
	static matchMedia(mediaQueryString: string): MediaQueryList {
		return window.matchMedia(mediaQueryString);
	}

	static open(url: string, windowName: string, windowFeatures?: string): Window {
		return window.open(url, windowName, windowFeatures);
	}

	static setTimeout(fn: any, delay?: number): void {
		window.setTimeout(fn, delay);
	}
}
